
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 23a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM.5 1l1.2.6a3.248 3.248 0 011.8 2.908V16a2 2 0 002 2h18","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.5 6v9a1 1 0 001 1h4a1 1 0 001-1V6a1 1 0 00-1-1h-4a1 1 0 00-1 1zm3-1v11m-1-8h2m-2 5h2m5-7v9a1 1 0 001 1h4a1 1 0 001-1V6a1 1 0 00-1-1h-4a1 1 0 00-1 1zm3-3v2m-3 9h6m-6-7h6","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    